import moment from "moment";
import 'moment/locale/de';
import 'moment/locale/en-gb';
import React, { Component } from 'react';

import Article from '../model/article';
import { getCurrentLangCode, getLangData } from '../services/lang';
import { getArticles } from "../services/strapiService";
import { parseMarkdown2Html } from '../util/markdownUtil';

type NewsState = {
    articles: Array<Article>;
};

class News extends Component<{}, NewsState> {

    constructor(props: Readonly<{}>) {
        super(props);
        this.state = {
            articles: []
        };
    }

    componentDidMount() {
        moment.locale(getCurrentLangCode());
        getArticles(getCurrentLangCode()).then(strapiRes => {
            this.setState({
                articles: strapiRes.entries,
            });
        });
    }

    render() {

        const langData = getLangData();
        const { articles } = this.state;

        return (
            <div className="container" >

                <div className="row my-4">
                    <div className="col">
                        <p className="h1 fw-300">{langData.news.header}</p>
                    </div>
                </div>
                {articles.map((a) => ArticleEntry(a))}
            </div >
        );
    }
}

function ArticleEntry(article: Article) {
    return (
        <div className="my-4" key={article.publishedAt.getTime()}>
            < hr />
            <div className="row mb-2">
                <div className="col">
                    <h3>
                        {article.title}
                    </h3>
                </div>
                <div className="col">
                    <p className="text-right">
                        {moment(article.publishedAt).format('LL')}
                    </p>
                </div>
            </div>
            <div className="row">
                <div className="col">
                    <p dangerouslySetInnerHTML={{
                        __html: parseMarkdown2Html(article.content)
                    }} />
                </div>
            </div>
        </div >
    );
}

export default News;